import { useEffect, useState } from "react";
import SupportWidget from "./SupportWidget";

// Chooses the support channel at runtime:
//   - REACT_APP_TAWK_ID set   → load Tawk.to live chat (its own floating bubble)
//   - REACT_APP_CRISP_ID set  → load Crisp live chat
//   - neither (or provider fails to load) → render the built-in ticket widget
//
// REACT_APP_TAWK_ID may be either "<propertyId>" or the full "<propertyId>/<widgetId>".
// If only the property id is given, set REACT_APP_TAWK_WIDGET_ID (defaults to "default").
export default function SupportLauncher() {
    const tawkId = process.env.REACT_APP_TAWK_ID;
    const tawkWidgetId = process.env.REACT_APP_TAWK_WIDGET_ID || "default";
    const crispId = process.env.REACT_APP_CRISP_ID;
    const [providerFailed, setProviderFailed] = useState(false);

    useEffect(() => {
        if (tawkId) {
            if (document.getElementById("cfai-tawk")) return;
            const path = tawkId.includes("/") ? tawkId : `${tawkId}/${tawkWidgetId}`;
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_LoadStart = new Date();
            const s = document.createElement("script");
            s.id = "cfai-tawk";
            s.async = true;
            s.src = `https://embed.tawk.to/${path}`;
            s.charset = "UTF-8";
            s.setAttribute("crossorigin", "*");
            s.onerror = () => { console.error("[Support] Tawk.to failed to load — falling back to built-in widget"); setProviderFailed(true); };
            document.body.appendChild(s);
        } else if (crispId) {
            if (document.getElementById("cfai-crisp")) return;
            window.$crisp = window.$crisp || [];
            window.CRISP_WEBSITE_ID = crispId;
            const s = document.createElement("script");
            s.id = "cfai-crisp";
            s.async = true;
            s.src = "https://client.crisp.chat/l.js";
            s.onerror = () => { console.error("[Support] Crisp failed to load — falling back to built-in widget"); setProviderFailed(true); };
            document.head.appendChild(s);
        }
    }, [tawkId, tawkWidgetId, crispId]);

    // A working third-party provider renders its own floating bubble, so don't also show ours.
    if ((tawkId || crispId) && !providerFailed) return null;
    return <SupportWidget />;
}
